import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex align-center me-2" }
const _hoisted_2 = {
  key: 0,
  class: "result-icon"
}
const _hoisted_3 = {
  key: 1,
  class: "icon-placeholder",
  style: {"width":"24px"}
}

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import SlideBar from './SlideBar.vue'
import { ExamTestQuestion, GroupExamTestQuestion, GroupQuestion } from '../../../api/v2/models/question'
import { LETTER_FORMAT } from '../../utils/constants'
import Exam from "../../../api/v2/models/exam"


export default /*@__PURE__*/_defineComponent({
  __name: 'QuestionGroupTestList',
  props: {
    groupExamTestQuestion: {},
    padding: { type: Boolean, default: true },
    questionNumber: {},
    active: { type: Boolean, default: false },
    isExamResultAfterQuestion: { type: Boolean, default: false },
    groupQuestions: { default: () => [] },
    exam: {}
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n()

const props = __props

const emit = __emit

const groupQuestion = computed(() => {
  return props.groupQuestions.find(item => item.groupId == props.groupExamTestQuestion.groupId) || null
})

const currentQuestion = computed((): ExamTestQuestion => {
  return props.groupExamTestQuestion.questions[0]
})

const title = computed(() => {
  if (currentQuestion.value.isDescriptionQuestion) {
    return t('question.description', { format: LETTER_FORMAT.UPTITLECASE })
  }
  return `${t('question.problem')} ${props.questionNumber}`
})

const userScore = computed(() => {
  return groupQuestion.value ? groupQuestion.value.userScore : 0
})

const maxScore = computed(() => {
  return groupQuestion.value ? groupQuestion.value.maxScore : 0
})

const isPass = computed(() => {
  if (props.exam?.autoDiagnosisEnabled) { return false }
  return userScore.value === maxScore.value
})

const isNotFullScore = computed(() => {
  if (props.exam?.autoDiagnosisEnabled) { return false }
  return userScore.value < maxScore.value && userScore.value > 0
})

const isNotPass = computed(() => {
  if (props.exam?.autoDiagnosisEnabled) { return false }
  return userScore.value === 0
})

const onClick = () => {
  emit('click', currentQuestion.value.id.toString())
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!

  return (_openBlock(), _createBlock(_component_v_list_item, {
    class: _normalizeClass({ 'answer-report': __props.padding, 'active': __props.active }),
    onClick: onClick,
    disabled: __props.active
  }, {
    prepend: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (__props.groupExamTestQuestion.isAnswered)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (__props.isExamResultAfterQuestion && groupQuestion.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (__props.exam.autoDiagnosisEnabled || isPass.value)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          color: "blue"
                        }, {
                          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                            _createTextVNode("mdi-check", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true),
                    (isNotFullScore.value)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 1,
                          color: "green"
                        }, {
                          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                            _createTextVNode("mdi-triangle-outline", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true),
                    (isNotPass.value)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 2,
                          color: "red"
                        }, {
                          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                            _createTextVNode("mdi-close", -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true)
                  ]))
                : (_openBlock(), _createBlock(_component_v_icon, {
                    key: 1,
                    color: "blue"
                  }, {
                    default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                      _createTextVNode("mdi-check", -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }))
            ], 64 /* STABLE_FRAGMENT */))
          : (_openBlock(), _createElementBlock("div", _hoisted_3))
      ]),
      _createElementVNode("div", {
        class: _normalizeClass([{ gray: currentQuestion.value?.isDescriptionQuestion }, "font-weight-medium me-2"])
      }, _toDisplayString(title.value), 3 /* TEXT, CLASS */)
    ]),
    default: _withCtx(() => [
      (__props.groupExamTestQuestion.questionCount === 1)
        ? (_openBlock(), _createBlock(_component_v_list_item_title, {
            key: 0,
            class: "question-header-title"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(currentQuestion.value.headerTitle), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true),
      (__props.groupExamTestQuestion.questionCount > 1 && !currentQuestion.value?.isDescriptionQuestion)
        ? (_openBlock(), _createBlock(SlideBar, {
            key: 1,
            current: __props.groupExamTestQuestion.questionAnsweredCount,
            total: __props.groupExamTestQuestion.questionCount,
            align: "right"
          }, null, 8 /* PROPS */, ["current", "total"]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class", "disabled"]))
}
}

})